var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiltersMobileDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.0244L2 13.0244",
    stroke: "#47596B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.00586L2 7.00586",
    stroke: "#47596B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.0247C12.5 12.1943 13.1736 11.5186 14 11.5186C14.8264 11.5186 15.5 12.1943 15.5 13.0247C15.5 13.8551 14.8264 14.5308 14 14.5308C13.1736 14.5308 12.5 13.8551 12.5 13.0247Z",
    fill: "#47596B",
    stroke: "#47596B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 7.00612C4.53125 6.1757 5.20481 5.5 6.03125 5.5C6.85769 5.5 7.53125 6.1757 7.53125 7.00612C7.53125 7.83653 6.85769 8.51223 6.03125 8.51223C5.20481 8.51223 4.53125 7.83653 4.53125 7.00612Z",
    fill: "#47596B",
    stroke: "#47596B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersMobileDark);
export default __webpack_public_path__ + "static/media/filters-mobile-dark.cce7175d.svg";
export { ForwardRef as ReactComponent };